const OfferSpendByAccountListTableLangKey = [
	'column_account_id',
	'column_account',
	'column_account_in_group',
	'column_kt_group',
	'column_amount',
	'column_date',
] as const

type IOfferSpendByAccountListTableLangKey = typeof OfferSpendByAccountListTableLangKey[number]

export type IOfferSpendByAccountListTableLang = {
	offer_spend_by_account_list_table: Record<IOfferSpendByAccountListTableLangKey, string>
}

const langEntries = OfferSpendByAccountListTableLangKey.map(
	(key: IOfferSpendByAccountListTableLangKey) => [key, `offer_spend_by_account_list_table.${key}`]
)

const langObj: Record<IOfferSpendByAccountListTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_ACCOUNT_LIST_TABLE_LANG_KEY: IOfferSpendByAccountListTableLang = {
	offer_spend_by_account_list_table: langObj
}
